export default __webpack_public_path__ + "static/1.1_EN-229df79dceb0809e719a29c9101d1807.png";